import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchUserToEdit, fetchCipGroupsAction, saveUser  } from '../actions/';
import UserEditPage from '../components/Users/UserEditPage';

class UserEditContainer extends Component {
  
  render() {
    const { actions } = this.props;
    const { userId } = this.props.params;
    const { cipGroups } = this.props;
    const { currentEditUser } = this.props;
    const { authInfo } = this.props;
    const { IsAdmin } = authInfo;
    
    return <UserEditPage IsAdmin={IsAdmin} authInfo={authInfo} actions={actions} userId={userId} currentEditUser={currentEditUser} cipGroups={cipGroups} onSaveUser={this.saveUser.bind(this)}/>;
  }

  componentDidMount() {
    const { userId } = this.props.params;
    const { actions } = this.props;
    actions.fetchUserToEdit(userId);
    actions.fetchCipGroupsAction();
  }

  saveUser(user){
    const { userId } = this.props.params;
    const { actions } = this.props;
    return actions.saveUser(userId, user).then(() => {
      this.props.router.push('/users'); 
    });
  }
}



UserEditContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    cipGroups : state.cipGroups,
    currentEditUser : state.currentEditUser,
    authInfo : state.authInfo
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchUserToEdit, fetchCipGroupsAction, saveUser};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(UserEditContainer);



// WEBPACK FOOTER //
// ./containers/UserEditContainer.js